var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ModuloItem',{attrs:{"dataitem":_vm.itemshome}})
}
var staticRenderFns = []

export { render, staticRenderFns }